// @flow
import * as React from 'react';
import styled from 'styled-components';
import ButtonIndex from 'components/ButtonIndex';
import Image from 'components/Image';
import LocalizedImage from 'components/LocalizedImage';
import {LayoutCenterMiddle} from 'components/Layout';
import {
  LocalizedParagraph,
  Paragraph,
  useLocalized,
} from 'components/Localized';
import Logo from 'components/Logo';
import * as VideoUtils from 'utils/videoUtils';
import ButtonNextPage from 'components/ButtonNextPage';
import SoundToggleButton from 'components/SoundToggleButton';
import {Disclaimer} from 'components/Disclaimer'

type Props = {
  onOpenModalIndex: () => void,
  openModalIndex: boolean,
  onNext: () => void,
  onSkip: () => void,
};

export default function ChargingStationD(props: Props): React.Element<any> {
  const localized = useLocalized();
  React.useEffect(()=>{
    VideoUtils.loadB02_3(true);
  }, []);
  const [disclaimerOpened, setDisclaimerOpened] = React.useState(false);

  React.useEffect(()=>{
    window.tagManager.drivingZoneCourseBChargingStationCheckYourDestinationPage();
  },[]);
  

  return (
    <main>
      <GuideWrapper>
        <div>
          <LocalizedParagraph {...localized.driving_b02_charging_072}/>
          <LocalizedParagraph {...localized.driving_b02_charging_071}/>
        </div>
        <GuideFrame>
          <div>
            <LocalizedParagraph {...localized.driving_b02_charging_073}/>
            <LocalizedParagraph {...localized.driving_b02_charging_074}/>
            <LocalizedImage id="img_b_root" source="./driving-zone/b/img-b-root.jpg" />
          </div>
          <GuideLine />
          <div>
            <div>
              <Image source="./driving-zone/b/img-ic-charging.png" />
              <div>
              <LocalizedParagraph {...localized.driving_b02_charging_081}/>
              <LocalizedParagraph {...localized.driving_b02_charging_092}/>
              </div>
            </div>
            <div>
              <Image source="./driving-zone/b/img-b-ic-distance.png" />
              <div>
              <LocalizedParagraph {...localized.driving_b02_charging_082}/>
              <Paragraph textKey="driving_b02_charging7_210303_001" onClick={()=>{
                setDisclaimerOpened(true);
              }} />
              </div>
            </div>
          </div>
        </GuideFrame>
      </GuideWrapper>
      <ButtonIndex onOpenModalIndex={props.onOpenModalIndex} />
      <ButtonNextPage title={localized.driving_b04_charging_075} onNext={()=>{
        window.tagManager.chargingStationCheckYourDestinationNextLinkClick();
        props.onNext();

      }} />
      <Logo />
      <SoundToggleButton />
      { !disclaimerOpened && 
      <Disclaimer textKey="disclaimer_B02d2" onPopupClose={()=>{
        setDisclaimerOpened(false);
      }} />
      }
      { disclaimerOpened && 
      <Disclaimer popupTextKey="disclaimer_B02d1_popup" onPopupClose={()=>{
        setDisclaimerOpened(false);
      }} />
      }

    </main>
  );
}

const GuideWrapper = styled(LayoutCenterMiddle)`
  display: flex;
  flex-direction: column;

  >:nth-child(1) {
    p {
      text-align: center;
    }
  }
`;

const GuideFrame = styled.div`
  width: ${props => props.theme.layout.mobile ? 410 : 820}px;
  height: ${props => props.theme.layout.mobile ? 200 : 385}px;
  margin-top: ${props => props.theme.layout.mobile ? 12 : 43}px;
  margin-bottom: ${props => props.theme.layout.mobile ? 27 : 0}px;

  border: solid 0.5px #dcdcdc;
  background-color: rgba(0, 0, 0, 0.7);

  display: flex;
  flex-direction: row;

  >:nth-child(1) {
    flex: 1;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    padding: ${props => props.theme.layout.mobile ? 15 : 42}px 0px;

    >:nth-child(3) {
      width: ${props => props.theme.layout.mobile ? 164 : 328}px;
      height: ${props => props.theme.layout.mobile ? 99 : 180}px;
      padding: ${props => props.theme.layout.mobile ? 10 : 20}px 0px;
    }
  }
  >:nth-child(3) {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    > div {
      width: calc(100% - ${props => props.theme.layout.mobile ? 38 : 70}px);
      display: flex;
      flex-direction: row;

      img {
        width: ${props => props.theme.layout.mobile ? 45 : 70}px;
        height: ${props => props.theme.layout.mobile ? 45 : 70}px;
        padding-right: 10px;
        pointer-events: auto;
      }

      > div {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: left;
        justify-content: center;
        
        >:nth-child(1) {
          padding-top: ${props => props.theme.layout.mobile ? 2 : 6}px;
          padding-bottom: ${props => props.theme.layout.mobile ? 10 : 11}px;
        }

        >:nth-child(2) {
          pointer-events: auto;

          >:nth-child(1) {

          }
          >:nth-child(2) {
            background-size: contain;
            background-repeat:no-repeat;
          }

        }

      }
    }

    >:nth-child(1) {
      padding-bottom: ${props => props.theme.layout.mobile ? 14 : 41}px;
    }
  }
`;

const GuideLine = styled.div`
  width: 1px;
  margin-top: ${props => props.theme.layout.mobile ? 21 : 42}px;
  margin-bottom: ${props => props.theme.layout.mobile ? 29 : 42}px;
  background-color: rgba(255, 255, 255, 0.2);
`;